module.exports = __webpack_public_path__ + "img/element-icons-logo-bbc.7b28ce40.svg";